export default __webpack_public_path__ + "static/media/bg-login.97c6aee3.jpg";